import axiosClient from "./axiosClient";

export interface DeviceMapping {
  _id?: string;
  brandId: string;
  locationId?: string;
  serialNumber: string;
  system: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const deviceApi = {
  getDevices(params: { page?: number; limit?: number; brandId?: string }): Promise<any> {
    const { page = 1, limit = 50, brandId = "" } = params;
    return axiosClient.get(
      `/deviceMapping/getDevices?page=${page}&limit=${limit}${brandId ? `&brandId=${brandId}` : ""}`
    );
  },

  getDeviceById(id: string): Promise<any> {
    return axiosClient.get(`/deviceMapping/getDeviceById?id=${id}`);
  },

  addDevice(data: DeviceMapping): Promise<any> {
    return axiosClient.post("/deviceMapping/addDevice", data);
  },

  updateDevice(data: DeviceMapping): Promise<any> {
    return axiosClient.put("/deviceMapping/updateDevice", data);
  },

  deleteDevice(id: string): Promise<any> {
    return axiosClient.delete(`/deviceMapping/deleteDevice?id=${id}`);
  },
};

export default deviceApi;
